/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/app.component.scss.shim.ngstyle.ts